module.exports = __webpack_public_path__ + "static/media/016.478cb008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/016.jpg
// module id = 523
// module chunks = 0